export const getbulkuploadlist = `
query GetAllCandidates(
  $page: Int
  $pageSize: Int
) {
  getAllCandidates(
    page: $page
    pageSize: $pageSize
  ) {
    success
    error
    message
 
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
 
    data {
      id
      jobTitle
      name
      phone
      dateOfApplication
      currentLocation
      preferredLocations
      totalExperience
      graduationDegree
      ugSpecialization
      ugYear
      pgDegree
      pgSpecialization
      pgYear
      gender
      dob
      createdBy
    }
  }
}
`

export const deletebulkdata = `
mutation DeleteCandidates($input: DeleteCandidateInput!) {
  deleteCandidate(input: $input) {
    success
    error
    message
  }
}`

export const bulkCandidatesearch = `query SearchCandidates(
  $search: String!,
  $page: Int!,
  $pageSize: Int!
) {
  searchCandidates(
    search: $search,
    page: $page,
    pageSize: $pageSize
  ) {
    success
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
 
    data {
      id
      jobTitle
      name
      phone
      dateOfApplication
      currentLocation
      preferredLocations
      totalExperience
      graduationDegree
      ugSpecialization
      ugYear
      pgDegree
      pgSpecialization
      pgYear
      gender
      dob
      createdBy
    }
  }
}`
